import { dateFns as moment } from '@pcln/date-fns-utils'
import {
  getStaticItemEventsData,
  getDynamicItemEventsData,
} from '../../../common/log-ga-event/logGaEvent-view-item-list'
import { logSelectItem } from '../../../common/log-ga-event/logGaEvent-select-item-listings'
import { getBundleTypeString } from '../../../listings-client/components/ListingsContent/helpers'

export const LogSelectItemListingsHelper = ({
  props,
  state,
  airports,
  cabinClass,
  itinerary,
  isFiltersApplied,
  isUserSignedIn,
  needsDelay,
}) => {
  const { activeTabId } = props
  const isSorted = props?.sortOptions['1']
  const getLengthofStay = moment(state.returnDate).diff(state.travelDate, 'days')
  const los = isNaN(getLengthofStay) ? '' : getLengthofStay
  const searchRequestParams = props?.pclnBootstrapData.searchRequest.params
  const formattedPurchaseWindow = moment(state.listingsLoadTimerStart).format().split('T')[0]
  const purchaseWindow = moment(state.travelDate).diff(formattedPurchaseWindow, 'days')
  const airportsArray = Object.keys(airports)
  const airportCodeParams = [state?.departingFrom.airportCode, state?.returningFrom.airportCode]

  // GA Static Events Data consistent throughout RT, MD, OW Trip selection
  const staticItemEventsData = getStaticItemEventsData({
    ...state,
    ...props,
    ap: purchaseWindow,
    los: los,
    cabinClass: cabinClass,
    airportsArray: airportsArray,
    searchRequestParams: searchRequestParams,
    isReshopExperience: props?.pclnBootstrapData?.isReshopExperience,
    bundleType: getBundleTypeString(
      props?.pclnBootstrapData?.bundleComponents,
      props?.pclnBootstrapData?.isPackageListings
    ),
    searchRequest: props.pclnBootstrapData.searchRequest || {},
  })

  const searchEventData = {
    ...staticItemEventsData,
    ...getDynamicItemEventsData({
      activeTabId: activeTabId,
      isFiltersApplied,
      isSorted: isSorted,
    }), // Dynamic is for slice change on RT departure select.
  }

  if (state?.tripType !== 'MD') {
    logSelectItem({
      itinerary,
      searchEventData,
      searchRequestParams,
      airportCodeParams,
      tripType: state?.tripType,
      hasRecommendedListings: props?.recommendedListings?.[props?.activeTabId]?.length > 0,
      isUserSignedIn,
      needsDelay,
    })
  }
}
